import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { Option } from '../../../core/types';
import Button from '../../ui/Button';
import Modal from '../../ui/Modal';
import RadioGroup from '../../ui/RadioGroup';
import useInjectScript from './useInjectScript';

const FollowUpButton = styled(Button).attrs(() => ({
  variant: 'primary',
  size: 'medium',
}))`
  vertical-align: top;
  transform: rotate(90deg);
  position: fixed;
  bottom: 350px;
  right: -74px;
  z-index: 9999;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 0 0;
`;

const StyledButton = styled(Button)`
  margin: 0 20px;
`;

const issueTypes = [
  { value: 'a269675a', label: 'Clinical Support' },
  { value: 'cb4b8f51', label: 'Complaint' },
  { value: 'a43b9ee7', label: 'Fax Medical Report' },
  { value: '9e1cd0c5', label: 'Mail CD' },
  { value: '12c9a694', label: 'Mail USB' },
  { value: '2c68769e', label: 'MIF Incomplete' },
  { value: 'a4e61418', label: 'Non-Clinical Support' },
  { value: '4833101f', label: 'Schedule Hold NP Call' },
  { value: 'c2e107d8', label: 'Schedule NP Call' },
  { value: 'a14e93be', label: 'Requisition' },
  { value: '4e8663e9', label: 'NP Consult' },
  { value: '83167b44', label: 'Online Booking' },
  { value: '29fbe10f', label: 'Influencer Prospect' },
  { value: 'c0b7ae22', label: 'Investor Prospect' },
  { value: '7814508c', label: 'Journalist Follow Up' },
  { value: '23a99360', label: 'Enterprise Prospect' },
  { value: 'eaa5c38a', label: 'Physician Prospect' },
];

const IssueButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedContainerId, setSelectedContainerId] = useState('');
  useInjectScript(selectedContainerId);

  const handleShowModal = useCallback(() => {
    setSelectedContainerId('');
    setShowPopup(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setShowPopup(false);
  }, []);

  const handleChange = useCallback((value: string) => {
    setSelectedContainerId(value);
  }, []);

  return (
    <React.Fragment>
      <FollowUpButton onClick={handleShowModal}>Follow Up Task</FollowUpButton>

      {showPopup && (
        <Modal title="Issue Type" onClose={handleCloseModal}>
          <RadioGroup
            name="issueType"
            title=""
            initialValue={''}
            onChange={handleChange}
            position="vertical"
            labelSize="large"
            column={3}
          >
            {issueTypes.map((option: Option, index: number) => (
              <RadioGroup.Input
                id={`${option.value}-${index}`}
                disabled={false}
                key={option.value}
                label={option.label}
                value={option.value}
              />
            ))}
          </RadioGroup>

          <ButtonsWrapper>
            <StyledButton
              variant="primary"
              size={'medium'}
              onClick={handleCloseModal}
              id="continue"
              disabled={!selectedContainerId}
            >
              {'Continue'}
            </StyledButton>
          </ButtonsWrapper>
        </Modal>
      )}
    </React.Fragment>
  );
};

export default IssueButton;
